import { createSelector } from '@ngrx/store';
import { systemLogRegisterSelector } from './system-log-register.reducer';

export const selectFilters = createSelector(systemLogRegisterSelector, (state) => {
   return state.filters;
});

export const selectIsOnSystemPage = createSelector(systemLogRegisterSelector, (state) => {
   return state.isOnSystemPage;
});
